import * as BootstrapModal from "@/shared/ui/bootstrapModal";

export class VideoIntroduction {
	private static WORK_AND_PROJECTTIME_INTRODUCTION_VIDEO_URL = messages["introductionvideo.url.projectAndWorkingTime"];
	private static WORKINGTIME_INTRODUCTION_VIDEO_URL = messages["introductionvideo.url.workingTime"];
	private static PROJECTTIME_INTRODUCTION_VIDEO_URL = messages["introductionvideo.url.projectTime"];
	private static WEB_FRAME_SRC_URL = "/timr/images/web-frame-blue.svg";

	public static show(firstShow = false) {
		let videoUrl;
		if (globals.workingTimeEnabled && globals.projectTimeEnabled) {
			videoUrl = this.WORK_AND_PROJECTTIME_INTRODUCTION_VIDEO_URL;
		} else if (globals.workingTimeEnabled) {
			videoUrl = this.WORKINGTIME_INTRODUCTION_VIDEO_URL;
		} else if (globals.projectTimeEnabled) {
			videoUrl = this.PROJECTTIME_INTRODUCTION_VIDEO_URL;
		}

		if (videoUrl) {
			const sidebarHelp = $("#sidebar-help");
			const modal = new BootstrapModal.Modal({
				title: "introductionvideo.panel.title",
				size: "modal-lg",
				escapeText: false,
				message: `<div class="text-center">
								<img class="web-frame" src='${VideoIntroduction.WEB_FRAME_SRC_URL}'  alt="web frame illustration" />
								<div class="yt-frame-container">
									<iframe src="${videoUrl}?rel=0&autoplay=0&vq=hd720&showinfo=0" />
								</div>
							</div>`,
				buttons: [{
					text: "dialog.close"
				}],
				backdrop: true,
				destroyOnClose: true,
				footer: false,
				css: {
					content: "modal-transparent"
				},
				onClose: () => {
					if (firstShow) {
						sidebarHelp.popover({
							template: `<div class="popover popover-bg-secondary">
									<i class="fal fa-info-circle" aria-hidden="true"></i>
									<div class="arrow"></div>
									<div class="popover-content"></div>
								</div>`,
							content: messages["introductionvideo.sidebar.helpNotification"],
							container: "body",
							animation: false
						})
							.popover("show")
							.click(() => sidebarHelp.popover("hide"));

						// Bind resize event
						$(window).bind("resize", function () {
							sidebarHelp.popover("show")
								.click(() => {
									sidebarHelp.popover("hide");
									$(window).off();
								});
						});
					}
				}
			});
			// we lock the modal while the enter animation plays so the user does not accidentally close it.
			modal.lock();
			modal.show();
			setTimeout(() => {
				modal.unlock();
			}, 500);
		}
	}
}

